import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as More } from 'assets/svg/icon-more.svg'

function IconMore(props: IconProps): JSX.Element {
  const title = 'icon-more'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <More {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconMore
